import {keyToCoords} from "../../coords/keyToCoords";
import {coordsToKey} from "../../coords/coordsToKey";
import {hasObstacleInPath} from "./calculateAvailableShootingCells";

/**
 * Ячейки, по которым стрелок в принципе может выстрелить: в радиусе стрельбы и
 * без препятствия на траектории (гора/крепость). В отличие от
 * calculateAvailableShootingCells здесь НЕ проверяется, есть ли на ячейке
 * подходящая цель — это чистая геометрия дальности и траектории, по которой
 * рисуется затемнение недоступных ячеек поля.
 *
 * Ячейка самого стрелка тоже считается доступной, чтобы не затемнять его.
 *
 * @param {string} shooterHexKey - hexKey стреляющего
 * @param {number} range - дальность стрельбы в ячейках
 * @param {Object} hexes - состояние гексов
 * @param {Object} specialBuildings - специальные строения
 * @param {Array} pendingShootingActions - ожидающие действия стрельбы
 * @param {Object} buildingsDamage - уже применённые повреждения строений
 * @param {Array} fortressesUnderConstruction - крепости в строительстве
 * @returns {Set<string>} множество hexKey, по которым возможен выстрел
 */
export const calculateShootingReachableCells = (
  shooterHexKey,
  range,
  hexes,
  specialBuildings,
  pendingShootingActions,
  buildingsDamage,
  fortressesUnderConstruction,
) => {
  const reachableCells = new Set([shooterHexKey]);

  const [shooterQ, shooterR] = keyToCoords(shooterHexKey);

  // Обход «диска» радиуса range в кубических координатах
  for (let dq = -range; dq <= range; dq++) {
    const minDr = Math.max(-range, -dq - range);
    const maxDr = Math.min(range, -dq + range);

    for (let dr = minDr; dr <= maxDr; dr++) {
      const hexKey = coordsToKey(shooterQ + dq, shooterR + dr);
      if (reachableCells.has(hexKey)) {
        continue;
      }

      const hasObstacle = hasObstacleInPath(
        shooterHexKey,
        hexKey,
        hexes,
        specialBuildings,
        pendingShootingActions,
        buildingsDamage,
        fortressesUnderConstruction,
      );

      if (!hasObstacle) {
        reachableCells.add(hexKey);
      }
    }
  }

  return reachableCells;
};
